import { icons, logos } from 'common'
import styled, { css } from 'styled-components'

const designerCssCommon = css`
  .yolorekt_logo {
    width: 160px;
    margin: 2px 0 0 20px;
    height: 100%;
    display: block;
  }
  .popup .popUpContainer {
    width: 100%;
    min-width: 300px;
    max-width: 600px;
    position: fixed;
    left: 50%;
    top: -100vh;
    -webkit-transition: top 0.5s ease;
    -moz-transition: top 0.5s ease;
    -o-transition: top 0.5s ease;
    transition: top 0.5s ease;
    transform: translateX(-50%);
    -webkit-box-shadow: 0 0 100px rgba(0, 0, 0, 0.4);
    -moz-box-shadow: 0 0 100px rgba(0, 0, 0, 0.4);
    box-shadow: 0 0 100px rgba(0, 0, 0, 0.4);
    border-radius: 10px;
    z-index: 99;
  }
  .popup .popUpContainer.wide-1200 {
    width: 100%;
    max-width: 1230px;
  }
  .popup article {
    max-height: 800px;
    height: fit-content;
    background-color: var(--overlay-pad-background);
    backdrop-filter: blur(20px);
    border-radius: 0 0 10px 10px;
    padding: 0 30px 30px 0;
    display: flex;
    flex-direction: row;
  }
  .popup article.full {
    border-radius: 10px;
    padding: 15px;
    flex-direction: column;
  }
  .popup a.closePopUp {
    top: -5px;
    left: -5px;
    -webkit-mask: url(${icons.close_window_icon}) center center / 22px auto no-repeat;
    mask: url(${icons.close_window_icon}) center center / 22px auto no-repeat;
    background: hsl(0, 0%, 100%);
    width: 22px;
    height: 22px;
    display: block;
    position: absolute;
    z-index: 1;
  }
  .popup:target {
    opacity: 1;
    top: 0;
  }
  .popup .closePopUpOutSide {
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    cursor: default;
  }
  .popup:target .popUpContainer {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transition: top 0.5s ease;
    -moz-transition: top 0.5s ease;
    -o-transition: top 0.5s ease;
    transition: top 0.5s ease;
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/lb_bids_stats.css */
  .asset .asset_icon {
    height: 14px;
    width: 14px;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/res.css */
  @media (max-width: 600px) {
    .popup article {
      height: 80vh;
      max-height: 80vh;
      overflow: visible;
      flex-direction: column;
    }
  }
  /*! CSS Used from: Embedded ; media=all */
  @media all {
    .st0 {
      fill: #ffffff;
    }
  }
`
const ShareButtonMenu = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/share-card.css */
  article.twitter_share .card_action_area {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 5px 0 15px 0;
    position: relative;
  }
  article.twitter_share button.share_card_button {
    width: fit-content;
    width: 326px;
    padding: 13px 50px 12px 78px;
    font-size: 0.9rem;
    font-weight: 600;
    position: relative;
  }
  article.twitter_share button.share_card_button:before {
    position: absolute;
    content: '';
    -webkit-mask: url(${icons.share_icon}) center center / 16px auto no-repeat;
    background: #fff;
    width: 16px;
    height: 18px;
    top: 50%;
    left: calc(50% - 105px);
    transform: translate(-50%, -50%);
  }
  article.twitter_share button.post_to_twitter {
    position: relative;
    border-radius: 0;
  }
  article.twitter_share button.copy_link_button {
    position: relative;
    border-radius: 0;
  }
  article.twitter_share button.download_image_button {
    position: relative;
    border-radius: 0;
  }
  article.twitter_share button.copy_image_button {
    position: relative;
    border-radius: 10px 10px 0 0;
  }
  article.twitter_share button.post_to_twitter:before {
    -webkit-mask: url(${icons.twitter_icon}) left center / auto 14px no-repeat;
    background: #fff;
    position: absolute;
    content: '';
    width: 18px;
    height: 14px;
    z-index: 1;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
  }
  article.twitter_share button.copy_link_button:before {
    background-image: url(${icons.copy_icon_white});
    background-position: left center;
    background-size: auto 14px;
    background-repeat: no-repeat;
    position: absolute;
    content: '';
    width: 14px;
    height: 14px;
    z-index: 1;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
  }
  article.twitter_share button.copy_image_button:before {
    background-image: url(${icons.copy_image_icon});
    background-position: left center;
    background-size: auto 16px;
    background-repeat: no-repeat;
    position: absolute;
    content: '';
    width: 16px;
    height: 16px;
    z-index: 1;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
  }
  article.twitter_share button.download_image_button:before {
    background-image: url(${icons.download_icon});
    background-position: left center;
    background-size: auto 17px;
    background-repeat: no-repeat;
    position: absolute;
    content: '';
    width: 17px;
    height: 17px;
    z-index: 1;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
  }
  article.twitter_share .card_action_area * {
    transition: none;
    -webkit-transition: none;
    -moz-transition: none;
  }
  article.twitter_share .card_action_area .menu {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    visibility: hidden;
    background: hsla(0, 0%, 100%, 0.1);
    backdrop-filter: blur(30px);
    border-radius: 10px;
    padding: 3px;
    z-index: 2;
  }
  article.twitter_share .card_action_area .menu > ul {
    border: 1px solid hsla(0, 0%, 100%, 0.1);
    border-radius: 10px;
  }
  article.twitter_share .card_action_area .menu > ul > li {
    padding: 0;
  }
  article.twitter_share .card_action_area .menu > ul > li > button {
    padding: 15px 22px 15px 40px;
    margin: 0 0 2px 0;
    width: 100%;
    font-size: 0.9rem;
    -webkit-appearance: button;
    -moz-appearance: button;
    text-transform: none;
    overflow: visible;
    text-align: left;
    cursor: pointer;
    display: flex;
    font-weight: 400;
    justify-content: flex-start;
    background: hsla(0, 0%, 0%, 0.6);
  }
  article.twitter_share .card_action_area .menu > ul > li > button:hover {
    background: hsla(0, 0%, 0%, 1);
  }
  article.twitter_share .card_action_area .menu > ul > li > button:active,
  article.twitter_share .card_action_area .menu > ul > li > button:focus {
    background: rgba(0, 0, 0, 0.08);
  }
  article.twitter_share .card_action_area button.share_card_button + .menu {
    display: inline-block;
    position: absolute;
  }
  article.twitter_share .card_action_area button.share_card_button + .menu:hover {
    visibility: visible;
  }
  article.twitter_share .card_action_area button.share_card_button:hover + .menu {
    visibility: visible;
  }
  article.twitter_share button.share_in_chat {
    position: relative;
    border-radius: 0 0 10px 10px;
  }
  article.twitter_share button.share_in_chat:before {
    -webkit-mask: url(${icons.chat_icon}) left center / auto 16px no-repeat;
    background: #fff;
    position: absolute;
    content: '';
    width: 16px;
    height: 16px;
    z-index: 1;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
  }
  @media (max-width: 600px) {
    article.twitter_share .card_action_area {
      flex-direction: column;
      align-items: center;
    }
    article.twitter_share button.post_to_twitter {
      margin: 0;
    }
  }
`

const cardWrapperCss = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/lb_bids_stats.css */
  #game_main_area .asset .asset_icon {
    height: 14px;
    width: 14px;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/share-card.css */
  .card_wrapper {
    width: 1200px;
    height: 675px;
    background: var(--share-card-background);
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    position: relative;
  }
  .card_wrapper .panel_top {
    width: 100%;
    display: flex;
    height: 260px;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    padding: 0;
    position: absolute;
    top: 20px;
  }
  .card_wrapper .panel_top .logo {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--main-logo) center center / contain no-repeat;
    height: 100%;
    max-height: 280px;
  }
  .card_wrapper .panel_bottom {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: row;
    align-items: center;
    height: 345px;
    padding: 30px;
  }
  .card_wrapper .panel_bottom .data_grid {
    display: flex;
    flex-direction: column;
    width: 50%;
    align-self: flex-end;
    padding: 0 0 10px 0;
  }
  .card_wrapper .panel_bottom .data_grid .row {
    display: flex;
    flex-direction: row;
    height: 55px;
  }
  .card_wrapper .panel_bottom .data_grid .row label {
    width: 300px;
    padding: 0 20px 0 0;
    text-align: right;
    font-weight: 300;
    font-size: 2rem;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .card_wrapper .panel_bottom .data_grid .row .data {
    padding: 0 0 0 20px;
    text-align: left;
    font-weight: 700;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 1.9rem;
    font-weight: 600;
  }
  .card_wrapper .panel_bottom .data_grid .row .data .asset {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .card_wrapper .panel_bottom .data_grid .row .data .asset .asset_icon {
    width: 35px;
    height: 35px;
    margin: 0 6px 0 0;
  }
  .card_wrapper .panel_bottom .roi {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    width: 50%;
  }
  .card_wrapper .panel_bottom .roi .data {
    font-size: 7.9rem;
    letter-spacing: -0.05em;
    font-weight: 700;
  }

  .card_wrapper .panel_bottom .roi label {
    font-size: 2.6rem;
    font-weight: 200;
  }
  .card_wrapper .url_footer {
    height: 65px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid hsla(0, 0%, 100%, 0.15);
  }
  .card_wrapper .url_footer .powered_by {
    font-size: 0.75rem;
    display: flex;
    flex-direction: row;
    white-space: nowrap;
    align-items: center;
    justify-content: flex-start;
    padding: 0 30px;
    width: 50%;
  }
  .card_wrapper .url_footer .powered_by img {
    margin: 0 0 0 5px;
    height: 25px;
  }
  .card_wrapper .url_footer .client_url {
    width: 50%;
    display: flex;
    justify-content: flex-end;
    padding: 0 30px;
    font-size: 1rem;
  }
  .card_wrapper .url_footer .client_url a {
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.4);
  }
  .card_wrapper .url_footer .client_url a:hover {
    border-bottom: 0;
  }
  @media (max-width: 1200px) {
    .card_wrapper {
      width: 100%;
      max-width: 1200px;
    }
  }
  @media (max-width: 1000px) {
    .card_wrapper {
      height: 500px;
    }
    .card_wrapper .panel_bottom .roi .data {
      font-size: 5rem;
      letter-spacing: -0.04em;
    }
    .card_wrapper .panel_top .logo img {
      max-height: 180px;
    }
    .card_wrapper .panel_top {
      height: 200px;
    }
    .card_wrapper .panel_bottom {
      height: 245px;
      padding: 30px;
    }
    .card_wrapper .panel_bottom .roi {
      width: 60%;
    }
    .card_wrapper .panel_bottom .data_grid {
      width: 40%;
    }
    .card_wrapper .panel_bottom .data_grid .row label {
      width: 150px;
      padding: 0 10px 0 0;
      font-size: 1.5rem;
    }
    .card_wrapper .panel_bottom .data_grid .row .data {
      padding: 0 0 0 10px;
      font-size: 1.4rem;
    }
    .card_wrapper .panel_bottom .data_grid .row {
      height: 35px;
    }
  }
  @media (max-width: 800px) {
    .card_wrapper {
      height: 640px;
    }
    .card_wrapper .panel_bottom {
      height: 370px;
      flex-direction: column;
    }
    .card_wrapper .panel_bottom .data_grid {
      align-self: center;
      padding-top: 20px;
    }
  }
`

const developerCSS = css`
  /* .popup {
    top: 0;
    opacity: 1;
  } */
  .pupup #share-card {
    width: 100%;
    height: 100%;
  }
  .popup .popUpContainer {
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .popup div.closePopUp {
    position: absolute;
    top: -10px;
    left: -10px;
    mask: url(${icons.close_window_icon}) center center / 22px auto no-repeat;
    background: hsl(0, 0%, 100%);
    width: 22px;
    height: 22px;
    display: block;
    z-index: 1;
  }
  .popup div.closePopUp:hover {
    cursor: pointer;
    background: hsl(0, 76.05633802816901%, 27.84313725490196%);
  }
  .card_wrapper .panel_bottom .roi .data.won {
    color: hsl(126, 100%, 45%);
  }
  .card_wrapper .panel_bottom .roi .data.lost {
    color: hsla(340, 88%, 46%, 1);
  }
  .asset.aapl .asset_icon {
    background: url(${({ assetIcon }) => assetIcon}) center center / auto 100% no-repeat;
    width: 50px;
  }
  .asset.aapl .asset_icon.two {
    background: url(${({ assetIcon2 }) => assetIcon2}) center center / auto 100% no-repeat;
    width: ${({ assetIcon2 }) => (assetIcon2 ? '50px' : 0)};
  }

  button:disabled {
    cursor: not-allowed !important;
    opacity: 0.5;
  }
  .hideActionMenu {
    visibility: hidden !important;
  }
`

export const OrderSharingCardCSS = styled.div`
  ${designerCssCommon}
  ${cardWrapperCss}
  ${ShareButtonMenu}
  ${developerCSS}
`
